<template>
  <slot />
  <el-divider
    v-if="item.type === 'divider'"
    :content-position="item.contentPosition"
  >
    {{ item.label }}
  </el-divider>
  <el-form-item
    v-else
    :label="item.label"
    :prop="item.prop"
    :labelWidth="item.labelWidth"
    :class="item?.children?.length ? 'tl-form-item_children' : ''"
  >
    <template v-if="item.type === 'input'">
      <el-input
        v-model="form[item.prop]"
        :style="style"
        clearable
        :disabled="item.disabled"
        :placeholder="item.placeholder || '请输入'"
        @change="item?.events?.change"
        @input="item?.events?.input"
      >
        <template v-if="item.prepend" #prepend>{{ item.prepend }}</template>
        <template v-if="item.append" #append>{{ item.append }}</template>
      </el-input>
    </template>
    <template v-if="item.type === 'textarea'">
      <el-input
        v-model="form[item.prop]"
        :style="style"
        clearable
        resize="none"
        type="textarea"
        :disabled="item.disabled"
        :rows="item.rows || 2"
        :placeholder="item.placeholder || '请输入'"
      />
    </template>
    <template v-if="item.type === 'inputNumber'">
      <div class="chss-flex">
        <span v-if="item.prepend" style="padding-right: 5px">{{
          item.prepend
        }}</span>
        <el-input-number
          v-model="form[item.prop]"
          :style="style"
          :disabled="item.disabled"
          clearable
          :min="item.min"
          :max="item.max"
          :value-on-clear="null"
          controls-position="right"
          :placeholder="item.placeholder || '请输入'"
        />
        <span v-if="item.append" style="padding-left: 5px">{{
          item.append
        }}</span>
      </div>
    </template>
    <template v-if="item.type === 'radio'">
      <el-radio-group
        v-model="form[item.prop]"
        :style="style"
        @change="item?.events?.change"
      >
        <el-radio
          v-for="row in item.data"
          :key="row[item?.dataProp?.value || 'code']"
          :label="row[item?.dataProp?.label || 'name']"
          :value="row[item?.dataProp?.value || 'code']"
        />
      </el-radio-group>
    </template>
    <template v-if="item.type === 'checkbox'">
      <el-checkbox-group
        v-model="form[item.prop]"
        :style="style"
        @change="item?.events?.change"
      >
        <el-checkbox
          v-for="row in item.data"
          :key="row[item?.dataProp?.value || 'code']"
          :label="row[item?.dataProp?.label || 'name']"
          :value="row[item?.dataProp?.value || 'code']"
          :disabled="item.disabled || false"
        />
      </el-checkbox-group>
    </template>
    <template v-if="item.type === 'select'">
      <el-select
        v-model="form[item.prop]"
        :style="style"
        :multiple="item.multiple"
        clearable
        collapse-tags
        collapse-tags-tooltip
        :max-collapse-tags="item.maxCollapseTags || 1"
        :placeholder="item.placeholder || '请选择'"
        @change="item?.events?.change"
      >
        <el-option
          v-for="row in item.data"
          :key="row[item?.dataProp?.value || 'code']"
          :label="row[item?.dataProp?.label || 'name']"
          :value="row[item?.dataProp?.value || 'code']"
        />
      </el-select>
    </template>
    <template v-if="item.type === 'cascader'">
      <el-cascader
        v-model="form[item.prop]"
        :style="style"
        :options="item.data"
        :props="item.dataProp"
        :placeholder="item.placeholder || '请选择'"
        @change="item?.events?.change"
      />
    </template>
    <template v-if="item.type === 'date' || item.type === 'datetime'">
      <el-date-picker
        v-model="form[item.prop]"
        clearable
        :disabled-date="item.disabledDate"
        :type="item.type"
        :style="style"
        :format="item.valueFormat || 'YYYY-MM-DD'"
        :value-format="item.valueFormat || 'YYYY-MM-DD'"
        :placeholder="item.placeholder || '请选择日期'"
      />
    </template>
    <template v-if="item.type === 'time'">
      <el-time-picker
        v-model="form[item.prop]"
        clearable
        :disabled-hours="item.disabledHours"
        :disabled-minutes="item.disabledMinutes"
        :disabled-seconds="item.disabledSeconds"
        :style="style"
        :format="item.valueFormat || 'HH:mm:ss'"
        :value-format="item.valueFormat || 'HH:mm:ss'"
        :placeholder="item.placeholder || '请选择时间'"
      />
    </template>
    <template v-if="item.type === 'timeSelect'">
      <el-time-select
        v-model="form[item.prop]"
        :style="style"
        :start="form.start"
        :step="form.step || '00:15'"
        :end="form.end"
        :format="item.valueFormat || 'HH:mm:ss'"
        :value-format="item.valueFormat || 'HH:mm:ss'"
        :placeholder="item.placeholder || '请选择时间'"
      />
    </template>
    <template v-if="item.type === 'switch'">
      <el-switch
        v-model="form[item.prop]"
        :active-value="item.activeValue || 1"
        :inactive-value="item.inactiveValue || 0"
        @change="item?.events?.change"
      />
    </template>
    <template v-if="item?.children?.length">
      <TlFormItem
        v-for="(children, index) in item.children"
        :key="children.prop"
        v-model="form"
        :item="children"
      >
        <el-form-item v-if="item.range">
          <span
            v-if="index === 1"
            :style="{ padding: item.separator ? '0 10px' : '0' }"
            >{{ item.separator === undefined ? "~" : item.separator }}</span
          ></el-form-item
        >
      </TlFormItem>
    </template>
  </el-form-item>
</template>
<script setup>
const form = defineModel();
const props = defineProps({
  item: {
    type: Object,
    default: () => {
      return {};
    }
  }
});
const style = computed(() => {
  return {
    width: props.item.width
  };
});
</script>
<style scoped lang="scss"></style>
